import "./sidebar.css";
import React, { useState } from "react";

import { AiTwotoneSetting } from "react-icons/ai";
import { BsFillPhoneVibrateFill } from "react-icons/bs";
import { MdLineStyle } from "react-icons/md";

import { ImLocation2 } from "react-icons/im";
import { SiGoogletagmanager } from "react-icons/si";

import { Link } from "react-router-dom";
import { FaBars, FaSearch } from "react-icons/fa";

import { MdMessage, MdTimeline } from "react-icons/md";

export default function Sidebar() {
  const [click, setClick] = useState(true);

  const handleClick = () => {
    setClick(click === false ? true : false);
  };
  return (
    <div className="sidebar">
      <div className="staticsidebar">
        <FaBars
          className="importedico3"
          onClick={(e) => {
            e.preventDefault();
            handleClick();
          }}
        />
        <FaSearch className="importedico3" />
      </div>
      <div className={click ? "sidebarwrapper" : "outcast"}>
        <div className="sidebarmenu">
          <h3 className="sidebartitle">Quick Menu</h3>
          <ul className="sidebarlist">
            <Link to="/account/" className="link">
              <li className="sidebarlistitem active">
                <MdLineStyle className="importedicons" />
                <h2>Home</h2>
              </li>
            </Link>
            <Link to="/account/analytics" className="link">
              <li className="sidebarlistitem">
                <MdTimeline className="importedicons" />
                <h2>Reports and Analytics </h2>
              </li>
            </Link>
          </ul>
        </div>

        <div className="sidebarmenu">
          <h3 className="sidebartitle">Configurations</h3>
          <ul className="sidebarlist">
            <Link to="/account/device" className="link">
              <li className="sidebarlistitem">
                <BsFillPhoneVibrateFill className="importedicons" />

                <h2>Hardware</h2>
              </li>
            </Link>
            <Link to="/account/settings" className="link">
              <li className="sidebarlistitem">
                <AiTwotoneSetting className="importedicons" />
                <h2>Settings</h2>
              </li>
            </Link>
          </ul>
        </div>

        <div className="sidebarmenu">
          <h3 className="sidebartitle">Notifications</h3>
          <ul className="sidebarlist">
            <Link to="/account/message" className="link">
              <li className="sidebarlistitem">
                <MdMessage className="importedicons" />

                <h2>Mail and Messages</h2>
              </li>
            </Link>
          </ul>
        </div>

        <div className="sidebarmenu">
          <h3 className="sidebartitle">Tracking</h3>
          <ul className="sidebarlist">
            <Link to="/account/track" className="link">
              <li className="sidebarlistitem">
                <ImLocation2 className="importedicons" />
                <h2>Locate Vehicle</h2>
              </li>
            </Link>

            <Link to="/account/management" className="link">
              <li className="sidebarlistitem">
                <SiGoogletagmanager className="importedicons" />
                <h2>Fleet Management</h2>
              </li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
}
